import service from '@/services/signingChecklist.service'
import { SigningChecklistOrderActionType } from '@/store/modules/signing-checklist-order/action_types'
import { SigningChecklistOrderMutationType } from '@/store/modules/signing-checklist-order/mutation_types'

export const actions: StoreActions<SigningChecklistOrderActionType, SigningChecklistOrderMutationType> = {
  CREATE_SIGNING_CHECKLIST_GROUP: async ({ commit }, { mnemo, position }) => {
    commit('SET_SIGNATURE_GROUP_CREATION_PENDING', true)
    try {
      const { data } = await service.createGroup(mnemo, position)
      return data.group
    } finally {
      commit('SET_SIGNATURE_GROUP_CREATION_PENDING', false)
    }
  },
  DELETE_SIGNING_CHECKLIST_GROUP: async ({ commit }, { mnemo, groupId }) => {
    commit('SET_SIGNATURE_GROUP_DELETION_PENDING', true)
    try {
      await service.deleteGroup(mnemo, groupId)
    } finally {
      commit('SET_SIGNATURE_GROUP_DELETION_PENDING', false)
    }
  },
  DELETE_SIGNING_CHECKLIST_STEP: async ({ commit }, { mnemo, stepId }) => {
    commit('SET_SIGNATURE_STEP_DELETION_PENDING', true)
    try {
      await service.moveStep(mnemo, stepId, -1)
    } finally {
      commit('SET_SIGNATURE_STEP_DELETION_PENDING', false)
    }
  },
  GET_SIGNING_CHECKLIST_GROUPS: async ({ commit }, mnemo) => {
    commit('SET_SIGNATURE_GROUPS_LOADING_PENDING', true)
    try {
      const { data } = await service.getsigningChecklistGroups(mnemo)
      commit('SET_SIGNATURE_GROUPS', data.groups)
    } finally {
      commit('SET_SIGNATURE_GROUPS_LOADING_PENDING', false)
    }
  },
  MOVE_SIGNING_CHECKLIST_GROUP: async ({ commit }, { mnemo, position, blockId }) => {
    commit('SET_SIGNATURE_GROUP_MOVING_PENDING', true)
    try {
      await service.moveGroup(mnemo, position, blockId)
    } finally {
      commit('SET_SIGNATURE_GROUP_MOVING_PENDING', false)
    }
  },
  MOVE_SIGNING_CHECKLIST_STEP: async ({ commit }, { mnemo, stepId, groupId }) => {
    commit('SET_SIGNATURE_STEP_MOVING_PENDING', true)
    try {
      await service.moveStep(mnemo, stepId, groupId)
    } finally {
      commit('SET_SIGNATURE_STEP_MOVING_PENDING', false)
    }
  },
}
